import FreeTrialToast from "./ReduxToast";

export default FreeTrialToast;